module.exports = __webpack_public_path__ + "img/logo.16e02061.svg";